import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EjecucionSubcuentaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EjecucionSubcuentaPage",
            ss: ss,
            ajax: {
                "url": ss.indexEjecucionSubcuenta(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Ejecucion', name: 'Ejecucion', title: 'Ejecución' },
                { data: 'Subcuenta', name: 'Susbcuenta', title: 'Subcuenta' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            ejecucions: [],
            subcuentas: [],
            ejecucionSubcuentas: [],
            ejecucionSubcuenta: {},

            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getEjecucion() {
            this.ss.listEjecucion().then(
                (result) => {
                    let response = result.data;
                    this.ejecuciones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getSubcuenta() {
            this.ss.listSubcuenta().then(
                (result) => {
                    let response = result.data;
                    this.subcuentas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newEjecucionSubcuenta() {
            this.ejecucionSubcuenta = {};
            this.$refs['frm-ejecucionSubcuenta'].show();
        },
        showEjecucionSubcuenta(id) {
            this.isLoading = true;
            this.ss.show(id).then(
                (result) => {
                    let response = result.data;
                    this.ejecucionSubcuenta = response.data;
                    this.$refs['view-ejecucionSubcuenta'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editEjecucionSubcuenta() {
            this.$refs['frm-ejecucionSubcuenta'].show();
            this.$refs['view-ejecucionSubcuenta'].hide();
        },
        cancelEjecucionSubcuenta() {
            if (this.ejecucionSubcuenta.id) {
                this.$refs['view-ejecucionSubcuenta'].show();
            }
            this.$refs['frm-ejecucionSubcuenta'].hide();
        },
        saveEjecucionSubcuenta() {
            this.ss.storeEjecucionSubcuenta(this.ejecucionSubcuenta).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-ejecucionSubcuenta'].hide();
                    this.$refs['datatable-ejecucionSubcuenta'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEjecucionSubcuenta() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyEjecucionSubcuenta(this.ejecucionSubcuenta)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-ejecucionSubcuenta'].hide();
                                this.$refs['datatable-ejecucionSubcuenta'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-EjecucionSubcuenta').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEjecucionSubcuenta(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            /*
            this.getEjecucion();
            this.getReparticion();
            this.getPartida();
            this.categoriaProgramatica();
            */
        }
    }
};
